import axios from "axios";

// Decouple apiRequest config settings
// const {
//   protocol,
//   domain,
//   port,
//   host
// } = window['runConfig'];

// export const API_URL= `${protocol}${domain}:${port}/${host}`;
export const API_URL = process.env.REACT_APP_API_CALL;

const apiRequest = axios.create({
  baseURL: API_URL,
});

apiRequest.interceptors.request.use(
  async (config) => {
    // config.headers = constants.JSON_HEADER;
    // if (firebaseAuth.currentUser) {
    //   config.headers[constants.AUTH_FIREBASE] = await firebaseAuth.currentUser.getIdToken(true);
    // }
    return config;
  },
  (error) => {
    /**
     * Add your error handlers here
     */
    return Promise.reject(error);
  }
);

export default apiRequest;
